module.exports = __webpack_public_path__ + "static/media/gptKnowledge.3d160570.mp4";